/** Read display name from JWT without verifying signature (client UI only). */
export function getDisplayNameFromToken(token: string | null): string | null {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const o = JSON.parse(json) as Record<string, unknown>;
    const uniqueName = o["unique_name"];
    if (typeof uniqueName === "string" && uniqueName) return uniqueName;
    const name =
      o["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
    if (typeof name === "string" && name) return name;
    const sub = o["sub"];
    if (typeof sub === "string" && sub) return sub;
  } catch {
    return null;
  }
  return null;
}

/** JWT `exp` claim in milliseconds (UTC), or null if missing (client only, no signature check). */
export function getJwtExpiresAtMs(token: string | null): number | null {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const o = JSON.parse(json) as Record<string, unknown>;
    const exp = o["exp"];
    if (typeof exp === "number") return exp * 1000;
  } catch {
    return null;
  }
  return null;
}

/** JWT `region` claim (admin home country). */
export function getRegionFromToken(token: string | null): string | null {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const o = JSON.parse(json) as Record<string, unknown>;
    const region = o["region"];
    if (typeof region === "string" && region.trim()) return region.trim();
  } catch {
    return null;
  }
  return null;
}
